import { getAuthCode } from "./getAuthCode";
export const updateVoiceApi = async (voices) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/updateVoices", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode(),voices:voices})
      });
    } catch (error) {
      console.log(error);
    }
  };